function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compose, withProps, setPropTypes } from 'recompose';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SidebarApplicationSection from "./ApplicationSection";
var enhancer = compose(withProps(function (_ref) {
  var application = _ref.application;
  var info = {
    extraCharges: 0
  };
  if (application) {
    info = _objectSpread({}, application);
    info.extraCharges = _.reduce(_.filter(info.service_charges, function (x) {
      return x.type !== 'Application';
    }), function (s, n) {
      return s + n;
    }, 0);
  }
  return {
    info: info
  };
}), withProps(function (_ref2) {
  var info = _ref2.info;
  var applicationFee = _.find(info.service_charges, function (x) {
    return x.type === 'Application';
  });
  var extraCharges = _.filter(info.service_charges, function (x) {
    return x.type !== 'Application';
  });
  var _ref3 = applicationFee || {},
    appPrice = _ref3.price,
    appTitle = _ref3.title;
  return {
    applicationFee: applicationFee,
    extraCharges: extraCharges,
    appPrice: appPrice,
    appTitle: appTitle
  };
}), setPropTypes({
  appPrice: PropTypes.string,
  appTitle: PropTypes.string,
  application: PropTypes.object,
  applicationFee: PropTypes.object,
  extraCharges: PropTypes.array,
  files: PropTypes.array,
  getStateInputValue: PropTypes.func,
  getStatusInputValue: PropTypes.func,
  hasPermission: PropTypes.func,
  info: PropTypes.object,
  isRowLoading: PropTypes.func,
  loading: PropTypes.bool,
  onActionClick: PropTypes.func,
  onFiles: PropTypes.func,
  onSubmittedToSchool: PropTypes.func,
  stateOptions: PropTypes.array,
  statusOptions: PropTypes.array
}));
export default enhancer(SidebarApplicationSection);